import { Component, Input, OnInit, inject } from '@angular/core';
import { Demand } from '../../../types/Demand';
import { ClientDataService, ClientErpTransmissionSettings } from '@lib/client';

@Component({
    selector: 'demand-transmission-info',
    templateUrl: './demand-transmission-info.component.html',
    styleUrls: ['./demand-transmission-info.component.scss'],
    standalone: false,
})
export class DemandTransmissionInfoComponent implements OnInit {
    private readonly clientDataService = inject(ClientDataService);

    @Input() public demand!: Demand;

    public settings?: ClientErpTransmissionSettings;

    private fetchSettings(): void {
        this.clientDataService
            .getErpTransmissionSettings()
            .subscribe((settings: ClientErpTransmissionSettings) => (this.settings = settings));
    }

    ngOnInit(): void {
        this.fetchSettings();
    }
}
